var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2150_19994)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6064 13.6008L12.0024 15.9228L15.276 13.6644L22.614 20.904C22.4204 20.9672 22.2156 20.9992 21.9996 21H2.0004C1.7364 21 1.4844 20.9484 1.2528 20.856L8.6064 13.6008ZM24 7.6512V18.9996C24 19.296 23.9352 19.5768 23.82 19.83L16.6272 12.7332L24 7.6512ZM0 7.7148L7.2504 12.6732L0.1272 19.7028C0.0437553 19.4777 0.00069479 19.2397 0 18.9996L0 7.7148ZM21.9996 3C23.1036 3 24 3.8952 24 5.0004V5.7036L11.9976 13.9776L0 5.772V5.0004C0 3.8964 0.8952 3 2.0004 3H21.9996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2150_19994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.aebedc0d940dde72d431b14790a2990e.svg";
export { ForwardRef as ReactComponent };